__turbopack_context__.v({
  "className": "enriqueta_1d1973ea-module__y96KYq__className",
  "variable": "enriqueta_1d1973ea-module__y96KYq__variable",
});
